import React, { Component } from 'react';

import { connect } from 'react-redux';
import { shuffle } from 'd3'
import Classnames from 'classnames';

import History from '../History';
import PortfolioConfiguration from './PortfolioConfiguration'
import Radio from '../components/Radio';
import Watermark from '../components/Watermark';

import runAnalysis from '../actions/query-api/run-analysis';
import { normalizedSum } from '../selectors/normalized-weights';

import { IMPT_INFO_default } from '../constants.js'

import './style.css';

const IMPT_INFO = window.portfolioMapper.importantInformationURL || IMPT_INFO_default

class Entry extends Component {

  constructor(props){
    super(props);
    this.state = {
      securityPresent: false
    };
  }

  componentWillMount(){
    // Force compare mode if optimizer is disabled
    if (!this.props.featureOptimizer){
      this.props.setCompareModeOriginal();
    }
  }

  componentWillUpdate(nextProps){
    const { originalPortfolio } = nextProps
    const securityPresent = originalPortfolio.reduce((t,v) => t || (v.type === "CS"), false);
    if(securityPresent && !this.state.securityPresent){
      this.props.setBestModel(false)
    }
    if(securityPresent !== this.state.securityPresent){
      this.setState({ securityPresent })
    }

  }

  render(){
    const {
      width,
      version,
      wtRegionCCYOptions,
      currency,
      originalPortfolio,
      proposedPortfolio,
      compareMode,
      inFocus,
      bestModel,
      bestModelOptions,
      normalizedSum,
      benchmarks,
      selectedBenchmark,
      TEXT,
      featuresBenchmarks,
      originalUsingModel,
      proposedUsingModel,
      wtRegion,
      featureOptimizer,
    } = this.props;

    const { securityPresent } = this.state
    let { investmentGoal, investmentGoalOptions } = this.props

    const {
      setCompareMode,
      setInvestmentGoal,
      setBestModel,
      setCurrency,
      setBenchmark,
      runAnalysis,
      confirmNormalize,
    } = this.props;

    if(!investmentGoal){
      investmentGoalOptions = shuffle(investmentGoalOptions).filter(d => d.value !== 'C')
      investmentGoal = investmentGoalOptions[0].value
      setInvestmentGoal(investmentGoal)
    }

    return (<div className="entry">
      <div className="grayout"></div>
      <Watermark page='entry' logoURL={window.portfolioMapper.logoURL} />
      <div>
        <div className="version">{"V" + version}</div>
        <h4 className="modal-link">
          <a href={IMPT_INFO} target="_blank">{TEXT.ImportantInformationLabel}</a>
        </h4>
      </div>

      {(compareMode 
      	? ["original", "proposed"]
      	: ["original"]).map((side, i, a) => 
  	    	<PortfolioConfiguration 
  	    		key={side} 
  	    		side={side}
            inFocus={side === inFocus} />)}

      {featuresBenchmarks && benchmarks.length
        ? <div className="benchmarks">
            <div className="benchmark-label">{TEXT.benchmarksDropdownLabel}</div>
            <Radio
              type="dropdown"
              values={[
                { value: 'null', label: TEXT.benchmarksNoneLabel },
                ...benchmarks.map(b => ({ value: b.externalID, label: b.name }))
              ]}
              selected={selectedBenchmark}
              onChange={setBenchmark}
            />
          </div>
        : null}

      {!compareMode && !originalPortfolio.length
        ? null
        : <div className="controls">
          {investmentGoalOptions != null && !compareMode
            ? <div className="control">
                <div className="control-label">{TEXT.investmentObjectiveLabel}</div>
                <Radio
                  type="dropdown"
                  values={investmentGoalOptions.filter(o => o.value !== 'C')}
                  selected={investmentGoal}
                  onChange={setInvestmentGoal}
                />
              </div>
            : null}

          {/* DPD-551 to be removed when models live - region check */}
          {bestModelOptions != null && !compareMode && wtRegionCCYOptions.length <= 1 && wtRegion === 'US'
            ? <div className="control">
                <div className="control-label">{TEXT.howShouldWeOptimizeLabel}</div>
                <Radio
                  type="dropdown"
                  values={bestModelOptions}
                  selected={bestModel}
                  onChange={setBestModel}
                  disable={securityPresent}
                />
              </div>
            : null}

          {wtRegionCCYOptions.length > 1
            ? <div className="control">
                <div className="control-label">{TEXT.whatCurrencyLabel}</div>
                <Radio
                  type="dropdown"
                  values={wtRegionCCYOptions}
                  selected={currency}
                  onChange={setCurrency}
                />
              </div>
            : null}
          
          <div className="run">
             <div className={Classnames( featureOptimizer ? "left-button" : "center-button")}>
              <button
                disabled={!originalPortfolio.length || (compareMode && !proposedPortfolio.length)}
                onClick={() => {
                  if (Math.abs(normalizedSum.original - 1) >= 0.01
                    || (normalizedSum.proposed && Math.abs(normalizedSum.proposed - 1) >= 0.01)) {
                    confirmNormalize(TEXT.normalizeValues);
                  } else {
                    runAnalysis();
                  }
                }}
              >
                {compareMode ? TEXT.runComparisonLabel : TEXT.runAnalysisLabel}
              </button>
            </div>
            
           { featureOptimizer ?  <div className="switch-mode">{TEXT.orLabel}</div> : null }

           { featureOptimizer ?
              <div className="right-button">
                  {/* Disable the button if either portfolio is using a model */}
                <button 
                  disabled={originalUsingModel || proposedUsingModel}
                  title={originalUsingModel || proposedUsingModel ? 'Change the original portfolio to return to optimize': null}
                  onClick={() => setCompareMode(!compareMode)}
                  >
                  <span className="not-mobile" >{compareMode ? TEXT.orGoBackToSinglePortfolioLabel : TEXT.orCompareLabel}</span>
                  <span className="mobile" >{compareMode ? TEXT.orGoBackToSinglePortfolioLabel : TEXT.compareLabel}</span>
                </button>
              </div>
            : null }
          </div>
          
        </div>}

      <History width={width} />

      {TEXT.importantInformationDisclosure ?       
        <div className='important-info-disclosure' dangerouslySetInnerHTML={{__html: TEXT.importantInformationDisclosure.replace(/\[\[LINK\]\]/g, IMPT_INFO)}}></div>
        : null }
    </div>)
  }
}

const mapStateToProps = state => ({
  version: state.version,
  wtRegionCCYOptions: state.wtRegionCCYOptions[state.wtRegion],
  originalPortfolio: state.entry.original.portfolio,
  proposedPortfolio: state.entry.proposed.portfolio,
	compareMode: state.entry.compareMode,
  inFocus: state.entry.inFocus,
  investmentGoal: state.entry.original.investmentGoal,
  investmentGoalOptions: state.investmentGoalOptions,
  bestModel: state.entry.original.bestModel,
  currency: state.entry.original.entityCCY,
  bestModelOptions: state.bestModelOptions,
  normalizedSum: normalizedSum(state),
  benchmarks: state.entry.benchmarks,
  selectedBenchmark: state.entry.selectedBenchmark,
  TEXT: state.complianceText,
  featuresBenchmarks: state.features.benchmarks,
  featureOptimizer: state.features.optimizer,
  originalUsingModel: state.entry.original.usingModel,
  proposedUsingModel: state.entry.proposed.usingModel,
  wtRegion : state.wtRegion,
})

const mapDispatchToProps = dispatch => ({
  setBenchmark(benchmark){
    dispatch({ type: 'SET_BENCHMARK', benchmark: benchmark })
  },
  setCurrency(value){
    dispatch({ type: 'SET_CURRENCY', value })
  },
  setCompareMode(mode){
    dispatch({ type: 'SET_COMPARE_MODE', mode });
  },
  setCompareModeOriginal(){
    dispatch({ type: 'SET_COMPARE_MODE_ORIGINAL' });
  },
  setInvestmentGoal(value) {
    dispatch({ type: 'SET_INVESTMENT_GOAL', value });
  },
  setBestModel(value) {
    dispatch({ type: 'SET_BEST_MODEL', value });
  },
  runAnalysis() {
    dispatch(runAnalysis());
  },
  confirmNormalize(message) {
    dispatch({
      type: 'DIALOG',
      message,
      buttons: [
        { label: 'Cancel' },
        { label: 'Yes', callback: () => dispatch(runAnalysis()) },
      ],
    });
  },

})

export default connect(mapStateToProps, mapDispatchToProps)(Entry);


// WEBPACK FOOTER //
// ./src/Entry/index.js